/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Guide_Intro_P1Inputs */

const es_marketplace_seo_spain_guide_intro_p1 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_Intro_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En Zarpar puedes reservar veleros, lanchas y experiencias náuticas con armadores locales en toda la costa española. Compara precios, elige fechas y zarpa desde el puerto que prefieras.`)
};

const gl_marketplace_seo_spain_guide_intro_p1 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_Intro_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En Zarpar podes reservar veleiros, lanchas e experiencias náuticas con armadores locais en toda a costa española. Compara prezos, elixe datas e zarpea dende o porto que prefiras.`)
};

const en_marketplace_seo_spain_guide_intro_p1 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_Intro_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On Zarpar you can book sailboats, motorboats and nautical experiences with local owners along the Spanish coast. Compare prices, pick dates and set sail from your preferred port.`)
};

/**
* | output |
* | --- |
* | "On Zarpar you can book sailboats, motorboats and nautical experiences with local owners along the Spanish coast. Compare prices, pick dates and set sail from..." |
*
* @param {Marketplace_Seo_Spain_Guide_Intro_P1Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_guide_intro_p1 = /** @type {((inputs?: Marketplace_Seo_Spain_Guide_Intro_P1Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Guide_Intro_P1Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_guide_intro_p1(inputs)
	if (locale === "en") return en_marketplace_seo_spain_guide_intro_p1(inputs)
	return es_marketplace_seo_spain_guide_intro_p1(inputs)
});